import styled from 'styled-components';

export const FilterDivider = () => {
  return (
    <StyledDivider>
      <div className='divider' />
    </StyledDivider>
  );
};

const StyledDivider = styled.div`
  padding: 16px 0;

  .divider {
    height: 1px;
    background-color: ${({ theme }) => theme.palette.stroke[0]};
  }
`;
